export default __webpack_public_path__ + "static/media/iwmi_neww.3f4e9f00.svg";